import { combineReducers } from 'redux';

import messageReducer from './messageReducer';
import millReducer from './millReducer';
import settingReducer from './settingReducer';

export default combineReducers({
    message: messageReducer,
    mill: millReducer,
    settings: settingReducer
});
